
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.363.515a.644.644 0 00-.515-.148L4.484 1.653a.643.643 0 00-.546.637v6.66a2.22 2.22 0 00-2.217.154 2.252 2.252 0 103.503 1.872V6.061l7.078-1.088v2.69a2.22 2.22 0 00-2.217.154 2.252 2.252 0 103.503 1.872V1.004a.643.643 0 00-.225-.49zM2.973 11.94a.965.965 0 110-1.93.965.965 0 010 1.93zm8.363-1.287a.965.965 0 110-1.93.965.965 0 010 1.93zm.966-6.987L5.224 4.755v-1.93l7.078-1.069v1.911z","fill":"#B2B2B2"}})])
          )
        }
      }
    